const SkeletonBlock = ({ className }: { className: string }) => (
  <div className={`animate-pulse bg-gray-200 rounded ${className}`} />
);

export const StatCardSkeleton: React.FC = () => {
  return (
    <div className="rounded-xl bg-white/80 border p-4 shadow-sm">
      <div className="flex items-start justify-between gap-4">
        {/* Left text section */}
        <div className="text-left w-full">
          <SkeletonBlock className="h-4 w-20 mb-2" />   {/* title */}
          <SkeletonBlock className="h-7 w-24 mb-2" />   {/* value */}
          <SkeletonBlock className="h-3 w-28" />        {/* subtitle */}
        </div>

        {/* Right icon placeholder */}
        <div className="hidden sm:block">
          <SkeletonBlock className="h-10 w-10 rounded-md" />
        </div>
      </div>
    </div>
  );
};

export default StatCardSkeleton;
